var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"index"},[(!_vm.$route.path.includes('/bsg/otd/preview'))?_c('apt-page-tab',{model:{value:(_vm.active),callback:function ($$v) {_vm.active=$$v},expression:"active"}}):_vm._e(),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }